import { indexOf } from "lodash"
import Vue from "vue"
import Vuex from "vuex"
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    destinations:{strCodes:[],locations:[]},
    rooms:[{ad:2,ch:0,ages: new Array()}],
    bdg_rooms:[{ad:2,ch:0,ages: new Array()}],
    checkin:'',
    checkout:'',
    packs:'',
    budget:'',
    bdg_checkin:'',
    bdg_checkout:'',
    bdg_packs:'',
    structures:[],
    transports:[],
    selectedPacks:{},
    firstFilter:false,
    filters:{},
    numFiltered:0, 
    numFilterActive:0,
    soluctionLists:[],
    aptsels:[],
    formSearchList:0,
    formSearchOffer:0,
    searchTranspMode:1,
    strquotelists:{},
    destOptions:[],
    aptsels:[],
    bookingstep:'init'

  },
  mutations: {
    setDestinations (state,destinations) {
      state.destinations = destinations
      
    },
    setRooms(state,rooms)
    {
      state.rooms = rooms
    },
    formSearchList(state,v){
      state.formSearchList = v
    },
    formSearchOffer(state,v){
      state.formSearchOffer = v
    },
    setBudgRooms(state,rooms){
      state.bdg_rooms = rooms
    },
    setBudget(state,budget){
      state.budget = budget
    },
    setfirstFilter(state,v)
    {
      state.firstFilter = v
    },
    setDestOptions(state,v)
    {
      state.destOptions = v
    },
    setDestApt(state,apts)
    {
      state.aptsels = apts
    },
    setFilters(state,fi)
    {
      state.filters = fi
      state.numFilterActive = 0
      for(let f in state.filters)
      {
        
          let filt = state.filters[f]
          if(typeof filt.applied != 'undefined' && filt.applied) state.numFilterActive ++
          else {
              if(typeof filt.list != 'undefined')
              {
                    filt.list.forEach((flist,i1)=>
                  {
                      if(typeof flist.applied != 'undefined' && flist.applied) state.numFilterActive ++
                  })
              }
            
          } 
      }
    },
    resetForm(state)
    {
      state.checkin=''
      state.checkout=''
      state.packs=''
      state.selectedPacks = {}
    },
    setStructures(state,structures){
      state.structures = structures
    },
    setTransports(state,transports)
    {
      state.transports = transports
    },
    setStructureByCode(state,str){
      
      state.structures['s'+str.code] = str.infodata
      state.structures['s'+str.code].updated = "1"
      state.structures['s'+str.code].visible = "1"
    },
    setStrSolution(state,str){
      
      state.structures['s'+str.code].solutionSelected = str.solutionSelected
    },
    setStrVisible(state,str){
      
      state.structures['s'+str.code].visible = str.visible
    },
    setPacks(state,packs){
      state.selectedPacks = packs
    },
    setCheckinout(state,date){
     if(date.in) state.checkin = date.in
     if(date.out) state.checkout = date.out
     if(date.packs) state.packs = date.packs
     
    },
    setCheckinoutBudget(state,date){
      if(date.in) state.bdg_checkin = date.in
      if(date.out) state.bdg_checkout = date.out
      if(date.packs) state.bdg_packs = date.packs
      
     },
    setNumFiltered(state,number){
      state.numFiltered = number
    },
    setaddCompare(state,obj)
    {
      if(state.soluctionLists.length < 5)
        state.soluctionLists.push(obj)
    },
    removeFromCompare(state,index)
    {
      state.soluctionLists.splice(index, 1)
    },
    setSearchTranspMode(state,mode){
      
      state.searchTranspMode = mode
    },
    setDestApt(state,apts)
    {
      state.aptsels = apts
    },
    setstrquotelists(state,v){
      
      state.strquotelists[v.code] = v.quotenumber
    },
    stepPack(state,mode)
    {
      let steps = ["init","pack","detpack","treat","room"]
      if(mode == -1)
      {
        if(state.bookingstep != 'init')
        {
          state.bookingstep = steps.indexOf(state.bookingstep)-1
          state.bookingstep = steps[state.bookingstep]
        }
      }
      if(mode == 1)
      {
        if(state.bookingstep != 'room')
        {
          state.bookingstep = steps.indexOf(state.bookingstep)+1
          state.bookingstep = steps[state.bookingstep]
        }
      }
    },
    
  },
  getters: {
      destinations: state => state.destinations,
      rooms: state => state.rooms,
      checkin: state => state.checkin,
      checkout: state => state.checkout,
      packs: state => state.packs,
      bdg_rooms: state => state.bdg_rooms,
      budget: state => state.budget,
      bdg_checkin: state => state.bdg_checkin,
      bdg_checkout: state => state.bdg_checkout,
      bdg_packs: state => state.bdg_packs,
      selectedPacks: state => state.selectedPacks,
      structures: state => state.structures,
      transports: state => state.transports,
      firstFilter: state => state.firstFilter,
      filters: state => state.filters,
      numFiltered: state => state.numFiltered,
      numFilterActive: state=>state.numFilterActive,
      soluctionLists: state=>state.soluctionLists,
      formSearchList: state=>state.formSearchList,
      formSearchOffer: state=>state.formSearchOffer,
      searchTranspMode: state=>state.searchTranspMode,
      aptsels: state=>state.aptsels,
      strquotelists: state=>state.strquotelists,
      destOptions: state=>state.destOptions,
      aptsels: state=>state.aptsels,
      bookingstep: state=>state.bookingstep,
  },
  actions:{
    loadAnagraficData() 
    {
      let helloapts = localStorage.getItem('nictrs')
      
      if(!helloapts)
      {
        let traspAna = {}
        window.axios.get(window.wsUrl+'static/transports', 
            {
            headers: {
                'Content-Type': 'application/json',
            } 
        })
        .then((response) => 
        {
            
            if(response.data.transports)
            {                        
                response.data.transports.forEach((a,x) => 
                {
                    if(typeof traspAna[a.code] === 'undefined') traspAna[a.code] = {}
                    traspAna[a.code][a.type] = a.name
                })
            localStorage.setItem('nictrs', JSON.stringify(traspAna))
            }
        })
        return traspAna
      }
      else return JSON.parse(helloapts)
    },
  }
})